import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

interface Props {
    icon: JSX.Element;
    title: string;
    sub: string;
    // red icon tile (Remove user)
    danger?: boolean;
    wide?: boolean;
    // grey line at the left of the footer
    footerNote?: string;
    // main action button; left out when the modal only closes (Connect a social account → Done)
    footer?: JSX.Element;
    cancelLabel?: string;
    onClose: () => void;
}

// shared shell for the Client settings modals: header (icon tile, title, ×), body, grey footer. Styled in ClientSettings.scss.
const SettingsModal: React.FC<Props> = ({ icon, title, sub, danger, wide, footerNote, footer, cancelLabel = 'Cancel', onClose, children }) => {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    return <div className="modal-overlay" onClick={onClose}>
        <div className={`cs-modal${wide ? ' wide' : ''}`} role="dialog" aria-modal="true" aria-label={title} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
                <span className={`icon-tile${danger ? ' danger' : ''}`}>{icon}</span>
                <div className="text">
                    <h2>{title}</h2>
                    <p>{sub}</p>
                </div>
                <button type="button" className="close" aria-label="Close" onClick={onClose}><FiX /></button>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
                <span className="note">{footerNote}</span>
                <button type="button" className="cancel" onClick={onClose}>{cancelLabel}</button>
                {footer}
            </div>
        </div>
    </div>;
};

export default SettingsModal;
